// WelcomeHeader.jsx

import React, { useState, useEffect, useRef } from 'react';
import styles from './WelcomeHeader.module.scss';
import fav from 'assets/img/fav.png'
import AuthModal from 'components/AuthModal/AuthModal';
import ProfileButton from 'components/ProfileButton/ProfileButton';
import ThemeToggle from 'components/ThemeToggle/ThemeToggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShoppingCart,
  faUtensils,
  faLaptopCode,
  faServer,
  faUsers,
  faCalendarAlt,
  faFilm,
  faTv,
  faImage,
  faPlane,
  faGift
} from '@fortawesome/free-solid-svg-icons';

const WelcomeHeader = ({ goBack, onOpenProfile, onOpenService, onNavigate }) => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const sidebarRef = useRef(null);
  const burgerRef = useRef(null);
  const dropdownTimeoutRef = useRef(null);

  useEffect(() => {
    const handler = () => setAuthOpen(true)
    window.addEventListener('openAuth', handler)
    return () => {
      window.removeEventListener('openAuth', handler)
      // Очищаем таймер при размонтировании
      if (dropdownTimeoutRef.current) {
        clearTimeout(dropdownTimeoutRef.current);
      }
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !sidebarRef.current?.contains(event.target) && !burgerRef.current?.contains(event.target)) {
        setMobileMenuOpen(false);
      }
      
      // Закрываем dropdown при клике вне его области
      if (openDropdown === 'services') {
        const dropdown = document.querySelector(`.${styles.dropdown}`);
        if (dropdown && !dropdown.contains(event.target)) {
          setOpenDropdown(null);
        }
      }
    };

    if (isMobileMenuOpen || openDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen, openDropdown]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = (category) => {
    setOpenDropdown(openDropdown === category ? null : category);
  };

  const handleDropdownClick = (category) => {
    // Переключаем dropdown по клику для всех устройств
    setOpenDropdown(openDropdown === category ? null : category);
  };

  // Упрощенный плоский список сервисов
  const services = [
    { id: 'shop', name: 'Магазин', icon: faShoppingCart },
    { id: 'donations', name: 'Донаты', icon: faGift },
    { id: 'food', name: 'Еда', icon: faUtensils },
    { id: 'it', name: 'IT услуги', icon: faLaptopCode },
    { id: 'servers', name: 'Серверы', icon: faServer },
    { id: 'community', name: 'Сообщество', icon: faUsers },
    { id: 'events', name: 'События', icon: faCalendarAlt },
    { id: 'movie', name: 'Фильмы', icon: faFilm },
    { id: 'anime', name: 'Аниме', icon: faTv },
    { id: 'media', name: 'Медиа', icon: faImage },
    { id: 'tourism', name: 'Туризм', icon: faPlane }
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo__wrapper} onClick={goBack} role="button" tabIndex={0} onKeyPress={(e) => { if (e.key === 'Enter') goBack(); }}>
        <img src={fav} className={styles.logo} alt="" />
        <div className={styles.logoTextWrapper}>
          {/* Inline SVG styled to match existing header look — reads 'NCORE' */}
          <svg className={styles.logoText} width="260" height="60" viewBox="0 0 260 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="NCORE logo text">
            <text x="0" y="46" fill="white" fontFamily="NCORE, Arial, sans-serif" fontWeight="700" fontSize="50">NCORE</text>
          </svg>
        </div>
      </div>
      <div className={styles.navbar}>
        <button className={styles.navButton} onClick={goBack}>Главная</button>
        <div className={styles.dropdown}>
          <div 
            className={styles.dropdownToggle}
            onClick={() => handleDropdownClick('services')}
          >
            Сервисы
            <span className={`${styles.dropdownArrow} ${openDropdown === 'services' ? styles.open : ''}`}>▼</span>
          </div>
          {openDropdown === 'services' && (
            <div className={`${styles.dropdownMenu} ${styles.show}`}>
              <div className={styles.servicesGrid}>
                {services.map(service => (
                  <button 
                    key={service.id} 
                    className={styles.serviceItem}
                    onClick={() => { 
                      onOpenService(service.id); 
                      setOpenDropdown(null); 
                    }}
                  >
                    <FontAwesomeIcon icon={service.icon} className={styles.serviceIcon} />
                    <span>{service.name}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        <button className={styles.navButton} onClick={() => onNavigate('about')}>О нас</button>
        <button className={styles.navButton} onClick={() => onNavigate('contacts')}>Контакты</button>
        <button className={styles.navButton} onClick={() => onNavigate('privacy')}>Конфиденциальность</button>
      </div>
      <div className={styles.enter_buttons}>
        <ThemeToggle />
        <ProfileButton onLoginClick={() => setAuthOpen(true)} onOpenProfile={onOpenProfile} />
      </div>
      {/* <div className={styles.burgerMenu} onClick={toggleMobileMenu}>
        <div className={`${styles.bar} ${isMobileMenuOpen ? styles.rotateBar1 : ''}`}></div>
        <div className={`${styles.bar} ${isMobileMenuOpen ? styles.hideBar2 : ''}`}></div>
        <div className={`${styles.bar} ${isMobileMenuOpen ? styles.rotateBar3 : ''}`}></div>
      </div>
      {isMobileMenuOpen && (
        <div className={styles.sidebar}>
          <a href="#aboutus" onClick={toggleMobileMenu}>О нас</a>
          <a href="#catalogs" onClick={toggleMobileMenu}>Наши каталоги</a>
          <a href="#contacts" onClick={toggleMobileMenu}>Контакты</a>
        </div>
      )} */}
      <div className={styles.burgerMenu} ref={burgerRef} onClick={toggleMobileMenu}>
        <div className={`${styles.bar} ${isMobileMenuOpen ? styles.rotateBar1 : ''}`}></div>
        <div className={`${styles.bar} ${isMobileMenuOpen ? styles.hideBar2 : ''}`}></div>
        <div className={`${styles.bar} ${isMobileMenuOpen ? styles.rotateBar3 : ''}`}></div>
      </div>
      {isMobileMenuOpen && (
        <div ref={sidebarRef} className={`${styles.sidebar} ${isMobileMenuOpen ? styles.open : ''}`}>
          <button className={styles.closeButton} onClick={toggleMobileMenu}>×</button>
          <button className={styles.mobileNavButton} onClick={() => { goBack(); toggleMobileMenu(); }}>Главная</button>
          <div className={styles.mobileCategory}>
            <div 
              className={`${styles.categoryTitle} ${styles.mobileCategoryToggle}`}
              onClick={() => toggleDropdown('mobile-services')}
            >
              Сервисы
              <span className={`${styles.mobileArrow} ${openDropdown === 'mobile-services' ? styles.open : ''}`}>▼</span>
            </div>
            {openDropdown === 'mobile-services' && (
              <div className={styles.mobileServicesContent}>
                {services.map(service => (
                  <button 
                    key={service.id} 
                    className={styles.mobileServiceItem}
                    onClick={() => { 
                      onOpenService(service.id); 
                      toggleMobileMenu(); 
                      setOpenDropdown(null); 
                    }}
                  >
                    <FontAwesomeIcon icon={service.icon} className={styles.serviceIcon} />
                    <span>{service.name}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
          <button className={styles.mobileNavButton} onClick={() => { onNavigate('about'); toggleMobileMenu(); }}>О нас</button>
          <button className={styles.mobileNavButton} onClick={() => { onNavigate('contacts'); toggleMobileMenu(); }}>Контакты</button>
          <button className={styles.mobileNavButton} onClick={() => { onNavigate('privacy'); toggleMobileMenu(); }}>Конфиденциальность</button>
        </div>
      )}
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
    </div>
  );
};

export default WelcomeHeader;
